/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { TextInput } from '@mantine/core';
import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { IConsultationOutcome } from '../../hooks/promises/getConsultationOutcomes';
import { filterOutcomes } from './helpers';

interface IOutcomesSearchBarProps {
  outcomeList: IConsultationOutcome[];
  setFilteredOutcomeList: (
    value: React.SetStateAction<IConsultationOutcome[] | undefined>
  ) => void;
  setShouldShowResultsFallback: React.Dispatch<React.SetStateAction<boolean>>;
  setSearchingOutcomes: React.Dispatch<React.SetStateAction<boolean>>;
  userInput: string;
  setUserInput: React.Dispatch<React.SetStateAction<string>>;
}

function OutcomesSearchBar({
  outcomeList,
  setFilteredOutcomeList,
  setShouldShowResultsFallback,
  setSearchingOutcomes,
  userInput,
  setUserInput,
}: IOutcomesSearchBarProps) {
  useEffect(() => {
    setShouldShowResultsFallback(false);
    const filtered = filterOutcomes(userInput, outcomeList);

    if (filtered.length > 0) {
      setSearchingOutcomes(true);
      setFilteredOutcomeList(filtered);
      setSearchingOutcomes(false);
    }

    if (userInput && filtered.length < 1) {
      setSearchingOutcomes(false);
      setShouldShowResultsFallback(true);
    }
  }, [userInput]);

  return (
    <TextInput
      placeholder="Search outcomes..."
      value={userInput}
      onChange={(e) => setUserInput(e.target.value)}
      rightSection={
        userInput ? (
          <div
            onClick={() => {
              setUserInput('');
            }}
            className="flex items-center justify-center w-10 h-[90%] mr-[2%] bg-slate-200 hover:cursor-pointer text-subtitle hover:text-white hover:bg-slate-400"
          >
            <FontAwesomeIcon icon={faClose} fontSize={15} />
          </div>
        ) : null
      }
    />
  );
}

export default OutcomesSearchBar;
